import React from 'react';
import { motion } from 'framer-motion';
import { categories } from '../data/content';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram, FiFacebook, FiAtSign, FiHeart } = FiIcons;

export default function CategoryPage({ onSelect, onAbout }) {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.8 }}
      className="relative z-10 w-full max-w-md px-6 py-6 md:py-10 h-full flex flex-col"
    >
      <div className="flex-1 w-full overflow-y-auto no-scrollbar flex flex-col">
        <div className="m-auto w-full flex flex-col items-center py-4">
          
          {/* 毛筆 LOGO 區塊 */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.2, delay: 0.2 }}
            className="relative mb-8 md:mb-10 flex flex-col items-center"
          >
            <div className="relative">
              <h1 className="font-brush text-6xl md:text-7xl text-ink-brown opacity-85 tracking-widest ml-4">
                輕舟
              </h1>
              <div className="absolute -right-4 bottom-2 w-5 h-5 border border-ink-red/60 rounded-sm flex items-center justify-center transform rotate-6 opacity-70 bg-ink-red/5">
                <span className="font-brush text-ink-red/80 text-[10px] leading-none">舟</span>
              </div>
            </div>
            <span className="font-handwriting text-xs text-ink-brown/40 tracking-[0.4em] mt-3 ml-2">
              Drift
            </span>
          </motion.div>

          <h2 className="font-handwriting text-ink-brown opacity-80 text-lg md:text-xl tracking-[0.2em] mb-6 md:mb-8 text-center leading-relaxed">
            有什麼心事，<br/>想在這裡放下？
          </h2>

          <div className="w-full space-y-4">
            {categories.map((cat, index) => (
              <motion.button
                key={cat.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 + 0.4 }}
                onClick={() => onSelect(cat)}
                className="w-full py-3.5 md:py-4 bg-white/40 border border-khaki-light/50 rounded-xl text-ink-brown font-handwriting text-lg tracking-[0.2em] hover:bg-khaki-light/30 hover:border-khaki/50 transition-all duration-300 shadow-[0_2px_10px_rgba(0,0,0,0.02)] active:scale-95"
              >
                {cat.label}
              </motion.button>
            ))}
          </div>

          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.2 }}
            className="mt-8 md:mt-10 text-center flex flex-col items-center space-y-5"
          >
            <p className="font-handwriting text-ink-brown/40 text-xs md:text-sm tracking-widest leading-loose">
              不留記憶，落水無痕。<br />
              字句一旦隨波漂走，便會徹底消散。<br />
              請安心地把重量交給湖水吧。
            </p>
            
            <button 
              onClick={() => onAbout()} // 不帶參數，正常進入頂部
              className="font-handwriting text-ink-brown/50 text-sm tracking-[0.2em] hover:text-ink-brown transition-colors border-b border-ink-brown/20 pb-1"
            >
              關於輕舟
            </button>
          </motion.div>

        </div>
      </div>

      {/* 底部社群與支持連結 */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        className="shrink-0 pt-4 pb-2 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-ink-brown/30 w-full"
      >
        <a href="https://www.instagram.com/homy.hk" target="_blank" rel="noopener noreferrer" className="p-2 hover:text-ink-brown/70 transition-all duration-500 hover:-translate-y-1">
          <SafeIcon icon={FiInstagram} className="w-[1.125rem] h-[1.125rem]" />
        </a>
        <a href="https://www.facebook.com/profile.php?id=61578745554661" target="_blank" rel="noopener noreferrer" className="p-2 hover:text-ink-brown/70 transition-all duration-500 hover:-translate-y-1">
          <SafeIcon icon={FiFacebook} className="w-[1.125rem] h-[1.125rem]" />
        </a>
        <a href="https://www.threads.com/@homy.hk" target="_blank" rel="noopener noreferrer" className="p-2 hover:text-ink-brown/70 transition-all duration-500 hover:-translate-y-1 flex items-center gap-1.5 font-handwriting tracking-widest text-sm">
          <SafeIcon icon={FiAtSign} className="w-4 h-4" /> 
          Threads
        </a>
        <div className="w-[1px] h-3 bg-ink-brown/20 hidden md:block"></div>
        {/* 帶參數 'support'，讓 AboutPage 知道要自動捲動 */}
        <button onClick={() => onAbout('support')} className="p-2 hover:text-ink-red/70 transition-all duration-500 hover:-translate-y-1 flex items-center gap-1.5 font-handwriting tracking-widest text-sm">
          <SafeIcon icon={FiHeart} className="w-4 h-4" /> 
          支持我們
        </button>
      </motion.div>
    </motion.div>
  );
}